import React from 'react'
import style from './sec1.module.css'
import Logo from './blackOpsLogo/Artboard 28@4x.png'
const Sec1 = () => {
  return (
    <div>
      <div dir='rtl' className={style.box}>
        <div>
          <img width={'200px'} className={style.imgLogo} src={Logo} alt="Logo" />
          {/* <h3> 9 חודשים ואתם בהייטק </h3> */}
          <h1> <span className={style.devOps}>FullStack</span> <br /> <span className={style.engineer}>Developer</span> </h1>
        </div>
      </div>
    </div>
  )
}

export default Sec1